























export default {
  name: 'ExpertFeedbacksItem'

  props:
    item:
      type: Object
      default: ->
        {}
    index: Number
    onLoadPage: Boolean
    isLast: Boolean

  computed:
    coverWidthPercent: ->
      value = Number(@item.rating_value)
      value = 0 if isNaN(value)
      clamped = Math.max(0, Math.min(5, value))
      100 - (clamped * 20)
}
